<template >
  <section>
     <!-- Content Header (Page header) -->
     <section class="content-header">
        <h1>
           Datos personales del colaborador
           <small>Percy</small>
        </h1>
        <ol class="breadcrumb">
           <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
           <li class="active">Marcaciones</li>
        </ol>
     </section>
     <!-- Main content -->
     <section class="content">
        <div class="row">
        <!-- left column -->
          <div class="col-md-12">


            <div class="col-md-9 col-sm-9">
              <div class="box box-primary">
                 <div class="box-header with-border">
                    <h3 class="box-title"></h3>
                 </div>
                 <!-- /.box-header -->
                 <!-- form start -->

                 <div class="box-body">

                   <div class="col-md-12">
                     <p>Situación laboral</p>

                     <p><b>APELLIDOS Y NOMBRES:</b> PBARRIENTOS CAMACURI PERCY VICENTE</p>

                     <p><b>AREA FUNCIONAL:</b>  OFICINA DE TECNOLOGIA DE LA INFORMACIÓN</p>

                     <p><b>CARGO:</b> Analista de Sistemas I</p>

                     <p>Se muestran a continuación las áreas que pueden aprobar su papeleta siempre que el responsable del nivel 1 no se encuentre disponible</p>



                   </div>

                   <br>
                   <br>

                   <div class="col-md-12">

                     <table class="table table-condensed">

                         <thead>
                           <tr style="background: #51ff51;">
                             <th style="padding:10px 10px;">AREA DE APROBACIÓN</th>
                             <th style="padding:10px 10px;">APROBADOR</th>
                             <th style="padding:10px 10px;">NIVEL</th>
                           </tr>
                         </thead>

                         <tbody>

                           <tr>
                             <td>OFICINA DE TECNOLOGIA DE LA INFORMACION</td>
                             <td>RODRIGUEZ ALEGRE CESAR RENE</td>
                             <td>1</td>
                           </tr>

                           <tr>
                             <td>DIRECCIÓN GENERAL DE ADMINISTRACIÓN</td>
                             <td>TERAN LUDWICK FABRIZIO JORGE</td>
                             <td>2</td>
                           </tr>


                           <tr>
                             <td>OFICINA DE GESTION Y DESARROLLO HUMANO</td>
                             <td>RODRIGUEZ ALEGRE CESAR RENE</td>
                             <td>3</td>
                           </tr>

                         </tbody>
                     </table>

                   </div>

                 </div>


              </div>

              <div class="col-md-12">
               <p>(*) En caso que haya algún error en está información favor de comunicarse con la Oficina de Gestión y Desarrollo Humano al anexo 144.</p>
              </div>



            </div>

            <div class="col-md-3 col-sm-3">

              <div class="col-md-12">

                <h1>Colaboradores de su área</h1>


                <div class="row">


                  <div class="col-md-12" style="margin-bottom : 10px">

                    <div class="col-md-5 col-sm-6">
                      <img src="http://icons.iconarchive.com/icons/custom-icon-design/silky-line-user/256/user-2-icon.png" class="img img-thumbnail">
                    </div>

                    <div class="col-md-7 col-sm-6">
                      <p>ESPINOZA DELGADO CESAR AUGOSTO</p>
                    </div>
                  </div>


                   <div class="col-md-12" style="margin-bottom : 10px">

                    <div class="col-md-5 col-sm-6">
                      <img src="http://icons.iconarchive.com/icons/custom-icon-design/silky-line-user/256/user-2-icon.png" class="img img-thumbnail">
                    </div>

                    <div class="col-md-7 col-sm-6">
                      <p>ESPINOZA DELGADO CESAR AUGOSTO</p>
                    </div>
                  </div>


                   <div class="col-md-12" style="margin-bottom : 10px">

                    <div class="col-md-5 col-sm-6">
                      <img src="http://icons.iconarchive.com/icons/custom-icon-design/silky-line-user/256/user-2-icon.png" class="img img-thumbnail">
                    </div>

                    <div class="col-md-7 col-sm-6">
                      <p>ESPINOZA DELGADO CESAR AUGOSTO</p>
                    </div>
                  </div>


                   <div class="col-md-12" style="margin-bottom : 10px">

                    <div class="col-md-5 col-sm-6">
                      <img src="http://icons.iconarchive.com/icons/custom-icon-design/silky-line-user/256/user-2-icon.png" class="img img-thumbnail">
                    </div>

                    <div class="col-md-7 col-sm-6">
                      <p>ESPINOZA DELGADO CESAR AUGOSTO</p>
                    </div>
                  </div>

                </div>


              </div>

            </div>


             <!-- general form elements -->

             <!-- /.box -->
          </div>

      </div>
     </section>
  </section>



</template>

<script>


  import config from '../../config';



export default {

  name : 'Inicio',
  data(){
    return {
      colaboradores : [],

    }
  },
  mounted(){

    /*
    axioss.get(config.serverURI+'aplicaciones/colaboradores')
      .then((response)=>{

        let data = response.data;

        this.colaboradores = data;

        console.log('Mi datos devuelto es ', data );
      })

    */
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/Inicio.vue